import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { CalcType } from '../../../lookups/CalcType';
import * as IndirectRateStructureActions from './indirect-rate-structure.actions';
import { IndirectRateStructure } from './indirect-rate-structure.model';

export const indirectRateStructuresFeatureKey = 'indirectRateStructures';

export interface State extends EntityState<IndirectRateStructure> {
    // additional entities state properties
    IndirectRateTypes: CalcType[];
}

export const adapter: EntityAdapter<IndirectRateStructure> =
    createEntityAdapter<IndirectRateStructure>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    IndirectRateTypes: []
});

const indirectRateStructureReducer = createReducer(
    initialState,
    on(IndirectRateStructureActions.addIndirectRateStructure, (state, action) =>
        adapter.addOne(action.indirectRateStructure, state)
    ),
    on(
        IndirectRateStructureActions.upsertIndirectRateStructure,
        (state, action) =>
            adapter.upsertOne(action.indirectRateStructure, state)
    ),
    on(
        IndirectRateStructureActions.addIndirectRateStructures,
        (state, action) => adapter.addMany(action.indirectRateStructures, state)
    ),
    on(
        IndirectRateStructureActions.upsertIndirectRateStructures,
        (state, action) =>
            adapter.upsertMany(action.indirectRateStructures, state)
    ),
    on(
        IndirectRateStructureActions.updateIndirectRateStructure,
        (state, action) =>
            adapter.updateOne(action.indirectRateStructure, state)
    ),
    on(
        IndirectRateStructureActions.updateIndirectRateStructures,
        (state, action) =>
            adapter.updateMany(action.indirectRateStructures, state)
    ),
    on(
        IndirectRateStructureActions.deleteIndirectRateStructure,
        (state, action) => adapter.removeOne(action.id, state)
    ),
    on(
        IndirectRateStructureActions.deleteIndirectRateStructures,
        (state, action) => adapter.removeMany(action.ids, state)
    ),
    on(
        IndirectRateStructureActions.loadIndirectRateStructures,
        (state, action) => adapter.setAll(action.indirectRateStructures, state)
    ),
    on(IndirectRateStructureActions.clearIndirectRateStructures, state =>
        adapter.removeAll(state)
    ),
    on(IndirectRateStructureActions.loadIndirectRateTypes, (state, action) => ({
        ...state,
        IndirectRateTypes: action.indirectRateTypes
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return indirectRateStructureReducer(state, action);
}
